export default "__VITE_ASSET__d08ac531__"